import { Button } from 'uikit';

import type React from 'react';

export const CollapseColumnHeader: React.FC<any> = ({ switchExpandAll, shownIds, rows, tableTreeItems }: any) => {
    const shown = String(shownIds?.sort());
    const isCollapseDisabled = shown === String(tableTreeItems.map((i: any) => i.id).sort());
    const isExpandDisabled = shown === String(rows.map((i: any) => i.id).sort());

    return (
        <div>
            <Button
                label="Развернуть все"
                onClick={() => switchExpandAll(true)}
                view="clear"
                disabled={isExpandDisabled}
                size="s"
            />
            <Button
                label="Свернуть все"
                onClick={() => switchExpandAll(false)}
                view="clear"
                disabled={isCollapseDisabled}
                size="s"
            />
        </div>
    );
};

CollapseColumnHeader.displayName = 'CollapseColumnHeader';
